export default "__VITE_ASSET__C218Vz4$__"